module.exports = __webpack_public_path__ + "static/media/unsplash_tE7_jvK-_YU.d02cddb7.jpg";